import React from 'react'
import './style.css'

const LifeAtAboutSection = () => {
    return (
        <>
            <section className="life-at-bitsclan-about-section">
                <div className="container">
                    <div className="row align-items-stretch">
                        <div className="col-lg-7 mb-4 mb-lg-0">
                            <div className="text-content">
                                <h2 className="life-at-bitsclan-about-main-heading">About Us</h2>
                                <p>At Bitsclan IT Solutions, we empower businesses to thrive in the digital era by delivering custom software development, AI-powered solutions, cloud services, & enterprise IT consulting. Since 2017, we’ve partnered with startups, enterprises, & global brands to design & build scalable technology that drives growth, efficiency, & innovation.</p>
                                <p>Our expertise spans across industries from healthcare & finance to e-commerce, real estate, & education helping organizations embrace digital transformation with confidence. Backed by a team of world-class engineers, consultants, & innovators, we deliver solutions that are flexible, secure, & future-ready.</p>
                            </div>
                            <div className="row mt-4">
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-3 mb-md-0">
                                    <div className="stats-box">
                                        <h3 className="stats-number">2017</h3>
                                        <p className="stats-label">Year Founded</p>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-3 mb-md-0">
                                    <div className="stats-box">
                                        <h3 className="stats-number">100+</h3>
                                        <p className="stats-label">Skilled Employees</p>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                                    <div className="stats-box">
                                        <h3 className="stats-number">5+</h3>
                                        <p className="stats-label">Countries Served</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="info-card p-4">
                                <div className="info-group mb-4">
                                    <h4 className="info-heading">At a Glance</h4>
                                    <div className="info-content">
                                        <span className="info-badge"><strong>2017</strong> Year Founded</span>
                                        <span className="info-badge"><strong>100+</strong> Skilled Employees</span>
                                        <span className="info-badge"><strong>5+</strong> Countries Served</span>
                                    </div>
                                </div>

                                <div className="info-group">
                                    <h4 className="info-heading">Global Presence</h4>
                                    <div className="info-content">
                                        <a href="https://maps.app.goo.gl/KLGhpKxNaL9qhyXq8" target='_blank'>
                                            <span className="info-badge">Head Office – <strong>New York, USA</strong></span>
                                        </a>

                                        <a href="https://maps.app.goo.gl/ujNgkiwdasgdErus5" target='_blank'>
                                            <span className="info-badge">Europe Office – <strong>Sweden</strong></span>
                                        </a>

                                        <a href="" target='_blnak'>
                                            <span className="info-badge">Gulf Office – <strong>KSA</strong></span>
                                        </a>
                                        <span className="info-badge">Australia Office – <strong>Australia</strong></span>
                                        {/* <span className="info-badge">South Asia Office – <strong>Pakistan</strong></span> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default LifeAtAboutSection